module.exports = __webpack_public_path__ + "img/money_ball_og.8fd4d04d.png";